var _defs, _polygon, _path, _polygon2, _path2, _polygon3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon4, _path12, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path13, _polygon11, _path14, _polygon12, _polygon13, _polygon14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon15, _path24, _polygon16, _path25, _polygon17, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon18, _path35, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path36, _polygon25, _path37, _polygon26, _polygon27, _polygon28, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 784.83 185.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c261b;}.cls-2{fill:#191919;}.cls-3{fill:#262626;}.cls-4{fill:#333332;}.cls-5{fill:#404040;}.cls-6{fill:#333;}.cls-7{fill:#5a5a5a;}.cls-8{fill:#595a5a;}.cls-9{fill:#656766;}.cls-10{fill:#727373;}.cls-11{fill:#4d4d4d;}.cls-12{fill:#7f8080;}.cls-13{fill:#8d8c8c;}.cls-14{fill:#999898;}.cls-15{fill:#b3b3b3;}.cls-16{fill:#e6e6e5;}.cls-17{fill:#cccccb;}.cls-18{fill:#a2a1a1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "homepage1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 182.05 38.7 182.05 0 169.92 0 182.05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6,382.1s-.89,4.39-7.12,6.73-13.14,2.37-16.94,2.37l38.69,12.13Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.6 156.01 38.7 182.05 24.06 160.82 64.6 156.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.1,388.7s-8.94.53-15-3c0,0-5.12-2.8-5.94-8.44l-25.9,26Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.7 181.92 85.56 167.41 38.7 182.05 95.7 181.92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.74,395.22s-11.79,5.33-22.94,6.53c0,0-9.51,1.32-15.56,1.45L114.1,388.7Z",
    transform: "translate(-28.54 -221.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.3,353.89s1.22,17.34-10.75,26.5a38,38,0,0,1-24.45,8.31l48.64,6.52Z",
    transform: "translate(-28.54 -221.28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.7,366.6l-39.4-12.71,13.44,41.33S184.14,387.54,188.7,366.6Z",
    transform: "translate(-28.54 -221.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.24,339.69l-.07,33.41s-.23,6.36-1.57,9l40.53-4.81Z",
    transform: "translate(-28.54 -221.28)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92,328v34.08s-.07,10.39,1.18,15.22l-38.89-37.6Z",
    transform: "translate(-28.54 -221.28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.49,330.06,149.3,353.89l39.4,12.71S194.05,346.65,181.49,330.06Z",
    transform: "translate(-28.54 -221.28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.87,325.61s9.75,9.06,9.43,28.28l32.19-23.83Z",
    transform: "translate(-28.54 -221.28)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M139.28,307.75s15,2.18,27.09,9.29,15.12,13,15.12,13l-41.62-4.45Z",
    transform: "translate(-28.54 -221.28)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.31,315.53s16.71-.85,26.56,10.08l-17.15-27.28Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "63.41 94.25 94.18 77.05 84.77 94.25 63.41 94.25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M92,301h10.81s12,.34,20-2.69L92,315.53Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "63.41 94.25 63.41 106.7 25.71 118.41 63.41 94.25"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "25.71 80.76 63.41 94.25 25.71 118.41 25.71 80.76"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "25.71 44.12 63.41 94.25 25.71 80.76 25.71 44.12"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "63.41 79.74 63.41 94.25 25.71 44.12 63.41 79.74"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94.18 77.05 110.74 86.47 111.33 104.33 94.18 77.05"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "25.71 44.12 63.41 37.44 63.41 79.74 25.71 44.12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M50.5,242s3.74,3.65,3.74,15.22v8.14L92,258.72Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "63.41 15.67 63.41 37.44 21.97 20.76 63.41 15.67"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M69.59,222.87,50.5,242s-2.8-6.07-22-5.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "0 2.49 0 14.88 41.06 1.59 0 2.49"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "63.41 15.67 41.06 1.59 21.97 20.76 63.41 15.67"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "80.42 0.91 63.41 15.67 41.06 1.59 80.42 0.91"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M127,240.84S119.63,237,105.79,237H92l17-14.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M141.13,283.12s-4.07,10.35-18.41,15.21l16.56,9.42Z",
    transform: "translate(-28.54 -221.28)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M160.39,299.48l-19.26-16.36-1.85,24.63A105,105,0,0,0,160.39,299.48Z",
    transform: "translate(-28.54 -221.28)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M144.42,267.8a33.94,33.94,0,0,1-3.29,15.32l38.49-3.25Z",
    transform: "translate(-28.54 -221.28)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.39,299.48s14.12-6.44,19.23-19.61l-38.49,3.25Z",
    transform: "translate(-28.54 -221.28)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M142.51,225s-13-3.06-33.55-2.83l18,18.65Z",
    transform: "translate(-28.54 -221.28)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169.8,237.88l-42.85,3L142.51,225A61.21,61.21,0,0,1,169.8,237.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M144.42,267.8s1.33-19-17.47-27l42.85-3Z",
    transform: "translate(-28.54 -221.28)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179.62,279.87l-35.2-12.07,25.38-29.92s10.4,7.9,11.55,20.84A36.77,36.77,0,0,1,179.62,279.87Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.94 182.05 440.63 182.05 401.94 169.93 401.94 182.05"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M454.53,382.11s-.89,4.39-7.12,6.72-13.13,2.38-16.94,2.38l38.7,12.13Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "466.54 156.02 440.63 182.05 426 160.83 466.54 156.02"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M516,388.7s-8.93.54-15-3c0,0-5.12-2.81-5.93-8.44l-25.9,26Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "497.64 181.92 487.5 167.42 440.63 182.05 497.64 181.92"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M564.68,395.23s-11.79,5.33-22.94,6.52c0,0-9.51,1.32-15.56,1.45L516,388.7Z",
    transform: "translate(-28.54 -221.28)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.23,353.9s1.23,17.33-10.74,26.5A38,38,0,0,1,516,388.7l48.65,6.53Z",
    transform: "translate(-28.54 -221.28)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M590.64,366.6l-39.41-12.7,13.45,41.33S586.08,387.54,590.64,366.6Z",
    transform: "translate(-28.54 -221.28)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M456.18,339.7l-.07,33.41s-.24,6.36-1.58,9l40.54-4.81Z",
    transform: "translate(-28.54 -221.28)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493.88,328v34.08s-.06,10.4,1.19,15.23l-38.89-37.6Z",
    transform: "translate(-28.54 -221.28)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M583.43,330.07l-32.2,23.83,39.41,12.7S596,346.66,583.43,330.07Z",
    transform: "translate(-28.54 -221.28)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M541.81,325.62s9.74,9.06,9.42,28.28l32.2-23.83Z",
    transform: "translate(-28.54 -221.28)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M541.21,307.76s15,2.17,27.1,9.29,15.12,13,15.12,13l-41.62-4.45Z",
    transform: "translate(-28.54 -221.28)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M515.24,315.53s16.71-.84,26.57,10.09l-17.16-27.28Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "465.35 94.25 496.12 77.06 486.71 94.25 465.35 94.25"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M493.88,301H504.7s12,.34,19.95-2.69l-30.77,17.19Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "465.35 94.25 465.35 106.71 427.64 118.42 465.35 94.25"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "427.64 80.77 465.35 94.25 427.64 118.42 427.64 80.77"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "427.64 44.13 465.35 94.25 427.64 80.77 427.64 44.13"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "465.35 79.75 465.35 94.25 427.64 44.13 465.35 79.75"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "496.12 77.06 512.68 86.47 513.27 104.34 496.12 77.06"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "427.64 44.13 465.35 37.45 465.35 79.75 427.64 44.13"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M452.44,242s3.74,3.66,3.74,15.22v8.15l37.7-6.68Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "465.35 15.68 465.35 37.45 423.9 20.76 465.35 15.68"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M471.53,222.88,452.44,242s-2.8-6.06-22-5.87Z",
    transform: "translate(-28.54 -221.28)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "401.94 2.49 401.94 14.89 443 1.6 401.94 2.49"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "465.35 15.68 443 1.6 423.9 20.76 465.35 15.68"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "482.36 0.91 465.35 15.68 443 1.6 482.36 0.91"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M528.89,240.85S521.57,237,507.73,237H493.88l17-14.77Z",
    transform: "translate(-28.54 -221.28)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M543.07,283.12s-4.07,10.36-18.42,15.22l16.56,9.42Z",
    transform: "translate(-28.54 -221.28)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M562.32,299.48l-19.25-16.36-1.86,24.64A104.68,104.68,0,0,0,562.32,299.48Z",
    transform: "translate(-28.54 -221.28)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M546.36,267.81a34.05,34.05,0,0,1-3.29,15.31l38.48-3.24Z",
    transform: "translate(-28.54 -221.28)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M562.32,299.48s14.13-6.43,19.23-19.6l-38.48,3.24Z",
    transform: "translate(-28.54 -221.28)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M544.44,225s-13-3.07-33.55-2.84l18,18.66Z",
    transform: "translate(-28.54 -221.28)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M571.73,237.88l-42.84,3L544.44,225A61.25,61.25,0,0,1,571.73,237.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M546.36,267.81s1.33-19-17.47-27l42.84-3Z",
    transform: "translate(-28.54 -221.28)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M581.55,279.88l-35.19-12.07,25.37-29.93s10.4,7.91,11.56,20.85A36.72,36.72,0,0,1,581.55,279.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M312,390.94,295.39,405.7s18.69,2.48,32.36,0Z",
    transform: "translate(-28.54 -221.28)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.09,384.61s-9.41,6.33-27.11,6.33l15.77,14.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.26,384.61s9.27,6.33,27.72,6.33L295.39,405.7Z",
    transform: "translate(-28.54 -221.28)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09,384.61l7.3,17.25a92.09,92.09,0,0,1-18.64,3.84Z",
    transform: "translate(-28.54 -221.28)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M284.26,384.61,257,393.5s13.88,9.26,38.35,12.2Z",
    transform: "translate(-28.54 -221.28)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.09,384.61l39.07.63s-14.88,12.22-31.77,16.62Z",
    transform: "translate(-28.54 -221.28)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.79,354.26s-5.77,20.19-23.7,30.35l39.07.63Z",
    transform: "translate(-28.54 -221.28)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258,347s4.66,25.91,26.29,37.65L257,393.5Z",
    transform: "translate(-28.54 -221.28)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.79,354.26l37,5.37s-8.9,17.07-21.62,25.61Z",
    transform: "translate(-28.54 -221.28)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M410.82,324.5s-2,21.53-11,35.13l-37-5.37Z",
    transform: "translate(-28.54 -221.28)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.67,313.42s-.3,28.72-5.88,40.84l48-29.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.25,294.49l-40.58,18.93,42.15,11.08S412.84,308.61,409.25,294.49Z",
    transform: "translate(-28.54 -221.28)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.72,376.57s5.39,7.89,21.32,16.93L258,347Z",
    transform: "translate(-28.54 -221.28)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.65,346.51s5.42,16.69,18.07,30.06L258,347Z",
    transform: "translate(-28.54 -221.28)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.93,325.73s.85,14.84,3,21.23l-40.32-.45Z",
    transform: "translate(-28.54 -221.28)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.79,313.68a99,99,0,0,0,5.86,32.83l37.28-20.78Z",
    transform: "translate(-28.54 -221.28)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M215.22,288.07s-3.81,14.15-3.43,25.61l43.14,12.05Z",
    transform: "translate(-28.54 -221.28)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M256.22,290a180.72,180.72,0,0,0-1.72,23.44s.05,7.26.43,12.31l-39.71-37.66Z",
    transform: "translate(-28.54 -221.28)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.87,289.37s2.09,16.11,1.8,24.05l40.58-18.93Z",
    transform: "translate(-28.54 -221.28)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M261.74,268.54s-4.44,11.7-5.52,21.44l-41-1.91Z",
    transform: "translate(-28.54 -221.28)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M357.07,260.62a84.28,84.28,0,0,1,9.8,28.75l42.38,5.12Z",
    transform: "translate(-28.54 -221.28)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M261.74,268.54l-46.52,19.53s6.05-25.93,26.93-43.62Z",
    transform: "translate(-28.54 -221.28)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M357.07,260.62l30.43-9.87s15.76,14.94,21.75,43.74Z",
    transform: "translate(-28.54 -221.28)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M242.15,244.45l34.17,3.77s-8.91,6.79-14.58,20.32Z",
    transform: "translate(-28.54 -221.28)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M346.44,248.19s7.66,6.61,10.63,12.43l30.43-9.87Z",
    transform: "translate(-28.54 -221.28)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M366.16,234.24s14.23,7.72,21.34,16.51l-41.06-2.56Z",
    transform: "translate(-28.54 -221.28)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M264.6,230.37s-15.33,7.17-22.45,14.08l34.17,3.77Z",
    transform: "translate(-28.54 -221.28)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M327,238.58a48.15,48.15,0,0,1,19.44,9.61l19.72-13.95Z",
    transform: "translate(-28.54 -221.28)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M343.23,225.09s13.81,3.42,22.93,9.15L327,238.58Z",
    transform: "translate(-28.54 -221.28)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M284.92,223.88l-8.6,24.34L264.6,230.37S276.93,225.23,284.92,223.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M311.72,237l-12.46-15.1s14.13-1.18,24.39.06Z",
    transform: "translate(-28.54 -221.28)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327,238.58A70,70,0,0,0,311.72,237l11.93-15Z",
    transform: "translate(-28.54 -221.28)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M343.23,225.09s-11.23-2.81-19.58-3.18L327,238.58Z",
    transform: "translate(-28.54 -221.28)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M299.26,221.85,297,238.34A81.46,81.46,0,0,1,311.72,237Z",
    transform: "translate(-28.54 -221.28)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M284.92,223.88,297,238.34l2.27-16.49S289.7,222.59,284.92,223.88Z",
    transform: "translate(-28.54 -221.28)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M276.32,248.22s7-7.17,20.67-9.88l-12.07-14.46Z",
    transform: "translate(-28.54 -221.28)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M714,390.88l-16.59,14.76s18.69,2.48,32.36,0Z",
    transform: "translate(-28.54 -221.28)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.07,384.55s-9.41,6.33-27.11,6.33l15.77,14.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.24,384.55s9.27,6.33,27.72,6.33l-16.59,14.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M741.07,384.55l7.3,17.25a92.09,92.09,0,0,1-18.64,3.84Z",
    transform: "translate(-28.54 -221.28)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M686.24,384.55,659,393.44s13.88,9.26,38.35,12.2Z",
    transform: "translate(-28.54 -221.28)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.07,384.55l39.07.62s-14.88,12.23-31.77,16.63Z",
    transform: "translate(-28.54 -221.28)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M764.77,354.2s-5.76,20.19-23.7,30.35l39.07.62Z",
    transform: "translate(-28.54 -221.28)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660,346.9s4.66,25.91,26.29,37.65L659,393.44Z",
    transform: "translate(-28.54 -221.28)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M764.77,354.2l37,5.36s-8.91,17.08-21.63,25.61Z",
    transform: "translate(-28.54 -221.28)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M812.8,324.44s-2,21.53-11,35.12l-37-5.36Z",
    transform: "translate(-28.54 -221.28)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M770.65,313.36s-.3,28.72-5.88,40.84l48-29.76Z",
    transform: "translate(-28.54 -221.28)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M811.23,294.43l-40.58,18.93,42.15,11.08S814.82,308.54,811.23,294.43Z",
    transform: "translate(-28.54 -221.28)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M637.7,376.51s5.4,7.89,21.32,16.93L660,346.9Z",
    transform: "translate(-28.54 -221.28)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M619.64,346.45s5.41,16.69,18.06,30.06L660,346.9Z",
    transform: "translate(-28.54 -221.28)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M656.91,325.67s.85,14.84,3,21.23l-40.31-.45Z",
    transform: "translate(-28.54 -221.28)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M613.77,313.62a98.86,98.86,0,0,0,5.87,32.83l37.27-20.78Z",
    transform: "translate(-28.54 -221.28)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M617.2,288s-3.81,14.15-3.43,25.61l43.14,12.05Z",
    transform: "translate(-28.54 -221.28)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M658.2,289.92a180.72,180.72,0,0,0-1.72,23.44s0,7.26.43,12.31L617.2,288Z",
    transform: "translate(-28.54 -221.28)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M768.85,289.31s2.09,16.11,1.8,24.05l40.58-18.93Z",
    transform: "translate(-28.54 -221.28)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M663.72,268.48s-4.44,11.7-5.52,21.44l-41-1.91Z",
    transform: "translate(-28.54 -221.28)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M759.05,260.56a84.28,84.28,0,0,1,9.8,28.75l42.38,5.12Z",
    transform: "translate(-28.54 -221.28)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M663.72,268.48,617.2,288s6-25.93,26.94-43.62Z",
    transform: "translate(-28.54 -221.28)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M759.05,260.56l30.44-9.87s15.75,14.94,21.74,43.74Z",
    transform: "translate(-28.54 -221.28)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M644.14,244.39l34.16,3.77s-8.91,6.79-14.58,20.32Z",
    transform: "translate(-28.54 -221.28)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M748.42,248.13s7.67,6.61,10.63,12.43l30.44-9.87Z",
    transform: "translate(-28.54 -221.28)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M768.14,234.18s14.23,7.72,21.35,16.51l-41.07-2.56Z",
    transform: "translate(-28.54 -221.28)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M666.59,230.31s-15.34,7.17-22.45,14.08l34.16,3.77Z",
    transform: "translate(-28.54 -221.28)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M729,238.52a48.09,48.09,0,0,1,19.44,9.61l19.72-13.95Z",
    transform: "translate(-28.54 -221.28)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M745.21,225s13.81,3.42,22.93,9.15L729,238.52Z",
    transform: "translate(-28.54 -221.28)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M686.9,223.82l-8.6,24.34-11.71-17.85S678.91,225.17,686.9,223.82Z",
    transform: "translate(-28.54 -221.28)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M713.7,236.89l-12.46-15.1s14.13-1.19,24.39.06Z",
    transform: "translate(-28.54 -221.28)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M729,238.52a69.88,69.88,0,0,0-15.28-1.63l11.93-15Z",
    transform: "translate(-28.54 -221.28)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M745.21,225s-11.22-2.81-19.58-3.18L729,238.52Z",
    transform: "translate(-28.54 -221.28)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M701.24,221.79,699,238.28a81.46,81.46,0,0,1,14.73-1.39Z",
    transform: "translate(-28.54 -221.28)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M686.9,223.82,699,238.28l2.27-16.49S691.68,222.53,686.9,223.82Z",
    transform: "translate(-28.54 -221.28)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M678.3,248.16s7-7.18,20.67-9.88L686.9,223.82Z",
    transform: "translate(-28.54 -221.28)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageDesign);
export default __webpack_public_path__ + "static/media/homepage-design.e4a5839cae2c762ea829bd5a5f4f9056.svg";
export { ForwardRef as ReactComponent };